import React, { useEffect, useState } from "react";
import './tvarumas.scss';
import qTvarumas from '@assets/gql/tvarumas.gql';
import qAttributes from '@assets/gql/tvarumas.attributes.gql';
import { useQuery } from "@apollo/client";
import client from "@gql/client";
import { LoadingBox } from "@assets/tsx/loadingBox/loadingBox";
import { Filters } from "@assets/tsx/list";
import { PaginatorButtons } from "@assets/tsx/paginator/buttons";
import { useListContext } from "@assets/spa/context/list";
import { useRouterPath } from "@ambiguous/useRouterPath";
import CardLinks from "@widgets/card-links/card-links";
import { __ } from "@wordpress/i18n";
import SidebarModal, { SidebarControllers } from "@assets/tsx/sidebarModal/SidebarModal";
import OutsideAlerter from "@assets/tsx/outsideClicker";
import ActiveFilters from "@assets/tsx/activeFilters/ActiveFilters";
const PER_PAGE = 6;
export default function TvarumasList({ _id, category, lang }) {
    const [lists, setLists] = useListContext();
    const listData = lists ? (lists[_id] || {}) : {};
    const [checkedFilters, setCheckedFilters] = useState(listData.checkedFilters || []);
    const [page, setPage] = useState((listData === null || listData === void 0 ? void 0 : listData.page) || 0);
    const [wrap, setWrap] = useState();
    const [path] = useRouterPath();
    const [toggleMenu, setToggleMenu] = useState(false);
    useEffect(() => {
        setLists && setLists((prev) => (Object.assign(Object.assign({}, prev), { [_id]: { path, checkedFilters, page } })));
    }, [page, checkedFilters]);
    const { filters, attrData } = useFilters(checkedFilters, lang);
    const { items, loading, total, fetchMore, } = useTvarumasList(category, attrData, checkedFilters, page, setPage, lang);
    return React.createElement("div", { className: "ltg-tvarumas ltg-list", ref: setWrap },
        React.createElement(ActiveFilters, { visible: true, setCheckedFilters: setCheckedFilters, labels: attrData, filters: checkedFilters, toggleMenu: () => {
                setToggleMenu(o => !o);
            } }),
        React.createElement("div", { className: "ltg-list-filters" },
            React.createElement("div", { className: 'ltg-list-filters-desktop' },
                React.createElement(Filters, { checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters, filters: filters }))),
        React.createElement("div", { className: "ltg-list-wrap" },
            loading ? React.createElement(React.Fragment, null,
                React.createElement("div", { className: "ltg-posts-list" },
                    React.createElement(LoadingBox, { style: { height: 300 } }),
                    React.createElement(LoadingBox, { style: { height: 300 } }),
                    React.createElement(LoadingBox, { style: { height: 300 } }))) : React.createElement(React.Fragment, null,
                React.createElement(List, { items: items })),
            total > 1 &&
                (React.createElement("div", { className: "ltg-posts-paginator-wrap" },
                    React.createElement(PaginatorButtons, { page: page, total: total, onClick: (clickedPage) => {
                            setPage(clickedPage);
                            fetchMore(clickedPage).then(() => {
                                wrap && wrap.scrollIntoView();
                            });
                        } })))),
        React.createElement(SidebarModal, { type: 'mobile', open: toggleMenu },
            React.createElement(OutsideAlerter, { className: 'ltg-modal-sidebar-wrap', callback: () => {
                    setToggleMenu(false);
                } },
                React.createElement(SidebarControllers, { isFilters: true, handleCloseMenu: () => {
                        setToggleMenu(false);
                    }, handleClearFilters: () => {
                        setCheckedFilters([]);
                    } }),
                React.createElement("div", { className: '.ltg_wrapper_visible_on_mobile' }, filters && Object.keys(filters).length > 0 &&
                    React.createElement(Filters, { checkedFilters: checkedFilters, setCheckedFilters: setCheckedFilters, filters: filters, setPage: setPage })))));
}
function List({ items }) {
    if (items && items.length === 0) {
        return React.createElement(React.Fragment, null,
            React.createElement("h1", { role: 'presentation', className: "text-center" }, __("Įrašų nėra", 'ltg-widgets')));
    }
    return React.createElement("div", { className: "ltg-posts-list" }, items === null || items === void 0 ? void 0 : items.map(({ id, title, uri, excerpt, featuredImage, date }) => {
        var _a, _b, _c;
        return React.createElement(CardLinks, { date: date.substring(0, 10), title: title, url: uri, key: id, image: {
                id: (_a = featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.node) === null || _a === void 0 ? void 0 : _a.databaseId,
                url: (_b = featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.node) === null || _b === void 0 ? void 0 : _b.mediaItemUrl,
                alt: (_c = featuredImage === null || featuredImage === void 0 ? void 0 : featuredImage.node) === null || _c === void 0 ? void 0 : _c.altText,
            }, url__props: {}, bg_color: undefined, buttons: [], content: excerpt });
    }));
}
function useFilters(checked, lang) {
    const { data, loading } = useQuery(qAttributes, {
        client,
        variables: {
            include: checked || [],
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        }
    });
    if (loading)
        return {};
    const flat = data.terms.nodes;
    const labeled = flat.reduce((agr, curr) => {
        var _a;
        const prevAttributes = !!agr[curr.taxonomyEnumValue] ? (_a = agr[curr.taxonomyEnumValue]) === null || _a === void 0 ? void 0 : _a.attributes : [];
        return Object.assign(Object.assign({}, agr), { [curr.taxonomyEnumValue]: {
                label: curr.taxonomyLabel,
                attributes: [
                    ...prevAttributes,
                    curr
                ]
            } });
    }, {});
    return { filters: labeled || {}, attrData: data };
}
function useTvarumasList(category, attrData, checkedFilters, page, setPage, lang) {
    var _a, _b, _c;
    let taxArray = [
        { field: 'SLUG', terms: category, taxonomy: 'TVARUMOKATEGORIJA' }
    ];
    if (attrData === null || attrData === void 0 ? void 0 : attrData.terms) {
        const checkedArr = attrData.terms.nodes.filter(f => checkedFilters.includes(f.databaseId));
        const filterMap = {};
        for (const attribute of checkedArr) {
            const { taxonomyEnumValue, databaseId } = attribute;
            if (!filterMap[taxonomyEnumValue]) {
                filterMap[taxonomyEnumValue] = [];
            }
            filterMap[taxonomyEnumValue].push(databaseId.toString());
        }
        const filterVar = Object.keys(filterMap).reduce((agr, fenum) => [...agr, { taxonomy: fenum, terms: filterMap[fenum], field: 'ID', operator: 'IN' }], []);
        if (filterVar.length !== 0) {
            taxArray = taxArray.concat(filterVar);
        }
    }
    const perPage = PER_PAGE;
    const { data, loading, fetchMore, refetch } = useQuery(qTvarumas, {
        client,
        variables: {
            taxArray: taxArray.length === 0 ? undefined : taxArray,
            perPage,
            offset: perPage * page,
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        },
        skip: !attrData
    });
    const fetchMoreItems = (page) => new Promise((res, rej) => {
        setPage(page);
        refetch({
            taxArray: taxArray.length === 0 ? undefined : taxArray,
            perPage,
            offset: perPage * page,
            language: lang === null || lang === void 0 ? void 0 : lang.toUpperCase()
        }).then(res).catch(err => { rej(err); });
    });
    const total = Math.ceil(((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.tvarumai) === null || _a === void 0 ? void 0 : _a.pageInfo) === null || _b === void 0 ? void 0 : _b.offsetPagination) === null || _c === void 0 ? void 0 : _c.total) / perPage) || 0;
    const items = data === null || data === void 0 ? void 0 : data.tvarumai.edges.map(edge => edge.node);
    return {
        items,
        loading,
        total,
        fetchMore: fetchMoreItems,
    };
}
